export default "__VITE_ASSET__DKexvahE__"